// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bez @tailwind base: nie dokladamy zmiennych ani resetu na poziomie globalnym. */
#sb-access-admin .m-3 {
    margin: 0.75rem
}
#sb-access-admin .mb-0 {
    margin-bottom: 0px
}
#sb-access-admin .mb-2 {
    margin-bottom: 0.5rem
}
#sb-access-admin .mb-3 {
    margin-bottom: 0.75rem
}
#sb-access-admin .mb-4 {
    margin-bottom: 1rem
}
#sb-access-admin .mt-0\\.5 {
    margin-top: 0.125rem
}
#sb-access-admin .mt-1 {
    margin-top: 0.25rem
}
#sb-access-admin .mt-3 {
    margin-top: 0.75rem
}
#sb-access-admin .block {
    display: block
}
#sb-access-admin .inline-block {
    display: inline-block
}
#sb-access-admin .flex {
    display: flex
}
#sb-access-admin .table {
    display: table
}
#sb-access-admin .grid {
    display: grid
}
#sb-access-admin .max-h-40 {
    max-height: 10rem
}
#sb-access-admin .w-full {
    width: 100%
}
#sb-access-admin .min-w-0 {
    min-width: 0px
}
#sb-access-admin .min-w-\\[720px\\] {
    min-width: 720px
}
#sb-access-admin .cursor-pointer {
    cursor: pointer
}
#sb-access-admin .list-none {
    list-style-type: none
}
#sb-access-admin .grid-cols-\\[100px_1fr\\] {
    grid-template-columns: 100px 1fr
}
#sb-access-admin .flex-col {
    flex-direction: column
}
#sb-access-admin .flex-wrap {
    flex-wrap: wrap
}
#sb-access-admin .items-center {
    align-items: center
}
#sb-access-admin .justify-between {
    justify-content: space-between
}
#sb-access-admin .gap-1 {
    gap: 0.25rem
}
#sb-access-admin .gap-2 {
    gap: 0.5rem
}
#sb-access-admin .gap-3 {
    gap: 0.75rem
}
#sb-access-admin .gap-4 {
    gap: 1rem
}
#sb-access-admin .self-start {
    align-self: flex-start
}
#sb-access-admin .overflow-auto {
    overflow: auto
}
#sb-access-admin .overflow-x-auto {
    overflow-x: auto
}
#sb-access-admin .whitespace-nowrap {
    white-space: nowrap
}
#sb-access-admin .whitespace-pre-wrap {
    white-space: pre-wrap
}
#sb-access-admin .rounded {
    border-radius: 0.25rem
}
#sb-access-admin .rounded-full {
    border-radius: 9999px
}
#sb-access-admin .rounded-md {
    border-radius: 0.375rem
}
#sb-access-admin .border {
    border-width: 1px
}
#sb-access-admin .border-b {
    border-bottom-width: 1px
}
#sb-access-admin .border-t {
    border-top-width: 1px
}
#sb-access-admin .border-\\[\\#dfe3ea\\] {
    --tw-border-opacity: 1;
    border-color: rgb(223 227 234 / var(--tw-border-opacity, 1))
}
#sb-access-admin .bg-\\[\\#e3f3ea\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(227 243 234 / var(--tw-bg-opacity, 1))
}
#sb-access-admin .bg-\\[\\#e8edf4\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(232 237 244 / var(--tw-bg-opacity, 1))
}
#sb-access-admin .bg-\\[\\#eaf1fb\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(234 241 251 / var(--tw-bg-opacity, 1))
}
#sb-access-admin .bg-\\[\\#eef1f5\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(238 241 245 / var(--tw-bg-opacity, 1))
}
#sb-access-admin .bg-\\[\\#f6f8fb\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(246 248 251 / var(--tw-bg-opacity, 1))
}
#sb-access-admin .bg-\\[\\#fbe4e4\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(251 228 228 / var(--tw-bg-opacity, 1))
}
#sb-access-admin .bg-\\[\\#fbefd9\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(251 239 217 / var(--tw-bg-opacity, 1))
}
#sb-access-admin .bg-white {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1))
}
#sb-access-admin .p-0 {
    padding: 0px
}
#sb-access-admin .p-2 {
    padding: 0.5rem
}
#sb-access-admin .p-3 {
    padding: 0.75rem
}
#sb-access-admin .px-1\\.5 {
    padding-left: 0.375rem;
    padding-right: 0.375rem
}
#sb-access-admin .px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem
}
#sb-access-admin .px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem
}
#sb-access-admin .py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem
}
#sb-access-admin .py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem
}
#sb-access-admin .py-px {
    padding-top: 1px;
    padding-bottom: 1px
}
#sb-access-admin .pb-2 {
    padding-bottom: 0.5rem
}
#sb-access-admin .pl-4 {
    padding-left: 1rem
}
#sb-access-admin .pt-3 {
    padding-top: 0.75rem
}
#sb-access-admin .text-left {
    text-align: left
}
#sb-access-admin .font-mono {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace
}
#sb-access-admin .text-\\[13px\\] {
    font-size: 13px
}
#sb-access-admin .text-base {
    font-size: 1rem;
    line-height: 1.5rem
}
#sb-access-admin .text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem
}
#sb-access-admin .text-xs {
    font-size: 0.75rem;
    line-height: 1rem
}
#sb-access-admin .font-medium {
    font-weight: 500
}
#sb-access-admin .font-normal {
    font-weight: 400
}
#sb-access-admin .font-semibold {
    font-weight: 600
}
#sb-access-admin .uppercase {
    text-transform: uppercase
}
#sb-access-admin .normal-case {
    text-transform: none
}
#sb-access-admin .tracking-wide {
    letter-spacing: 0.025em
}
#sb-access-admin .text-\\[\\#1d7a46\\] {
    --tw-text-opacity: 1;
    color: rgb(29 122 70 / var(--tw-text-opacity, 1))
}
#sb-access-admin .text-\\[\\#5d6878\\] {
    --tw-text-opacity: 1;
    color: rgb(93 104 120 / var(--tw-text-opacity, 1))
}
#sb-access-admin .text-\\[\\#9a5b00\\] {
    --tw-text-opacity: 1;
    color: rgb(154 91 0 / var(--tw-text-opacity, 1))
}
#sb-access-admin .text-\\[\\#a32020\\] {
    --tw-text-opacity: 1;
    color: rgb(163 32 32 / var(--tw-text-opacity, 1))
}
#sb-access-admin .filter {
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}
#sb-access-admin .hover\\:bg-\\[\\#eef1f5\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(238 241 245 / var(--tw-bg-opacity, 1))
}
@media (min-width: 1024px) {
    #sb-access-admin .lg\\:grid-cols-\\[1fr_340px\\] {
        grid-template-columns: 1fr 340px
    }
}
`, "",{"version":3,"sources":["webpack://./src/SecondBrain/sbTailwind.css"],"names":[],"mappings":"AAAA,kFAAkF;AAElF;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,eAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAFnB;IAAA,kBAGA;IAHA;AAGA;AAHA;IAAA;QAAA;IAGA;AAAA","sourcesContent":["/* Bez @tailwind base: nie dokladamy zmiennych ani resetu na poziomie globalnym. */\n@tailwind components;\n@tailwind utilities;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
